// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"vy_a bhk_b"};